/* Description truncation */

(function () {
  function initDescriptionToggle(description) {
    const toggle = description.nextElementSibling;
    if (!toggle || !toggle.classList.contains('product__description-toggle')) return;

    const maxChars = parseInt(description.dataset.maxChars) || 220;
    const fullText = description.textContent.trim();

    if (fullText.length <= maxChars) return;

    const originalHTML = description.innerHTML;
    const truncatedText = fullText.slice(0, maxChars).trimEnd() + '\u2026';

    description.textContent = truncatedText;
    toggle.hidden = false;

    let expanded = false;
    toggle.addEventListener('click', function () {
      expanded = !expanded;
      if (expanded) {
        description.innerHTML = originalHTML;
        toggle.textContent = toggle.dataset.labelLess;
      } else {
        description.textContent = truncatedText;
        toggle.textContent = toggle.dataset.labelMore;
      }
    });
  }

  function run(root) {
    (root || document).querySelectorAll('.product__description--truncatable').forEach(initDescriptionToggle);
  }

  run();

  document.addEventListener('shopify:section:load', function (e) {
    run(e.target);
  });
})();

/* Drawer tab */

(function () {
  var currentCloseDrawer = null;

  function initDrawer(triggerWrapper) {
    const trigger = triggerWrapper.querySelector('.product__drawer-trigger');
    if (!trigger) return;

    const drawerId = trigger.getAttribute('aria-controls');
    const drawer = document.getElementById(drawerId);
    if (!drawer) return;

    document.body.appendChild(drawer);

    const overlay = drawer.querySelector('.product__drawer-overlay');
    const closeBtn = drawer.querySelector('.product__drawer-close');
    let previouslyFocused = null;

    var panel = drawer.querySelector('.product__drawer-panel');

    function openDrawer() {
      if (currentCloseDrawer) currentCloseDrawer();
      previouslyFocused = document.activeElement;
      currentCloseDrawer = closeDrawer;
      drawer.hidden = false;

      requestAnimationFrame(function () {
        // panel is off-screen via transform — safe to measure without visible jump
        var margin = 16;
        var triggerRect = triggerWrapper.getBoundingClientRect();
        var panelHeight = panel.offsetHeight;
        var top = Math.max(margin, triggerRect.top);
        var maxTop = window.innerHeight - panelHeight - margin;
        panel.style.top = Math.max(margin, Math.min(top, maxTop)) + 'px';

        requestAnimationFrame(function () {
          drawer.classList.add('product__drawer--open');
        });
      });

      trigger.setAttribute('aria-expanded', 'true');
      closeBtn.focus({ preventScroll: true });
    }

    function closeDrawer() {
      currentCloseDrawer = null;
      drawer.classList.remove('product__drawer--open');
      trigger.setAttribute('aria-expanded', 'false');
      drawer.addEventListener('transitionend', function handler(e) {
        if (e.target !== drawer.querySelector('.product__drawer-panel')) return;
        drawer.hidden = true;
        drawer.removeEventListener('transitionend', handler);
      });
      if (previouslyFocused) previouslyFocused.focus({ preventScroll: true });
    }

    trigger.addEventListener('click', openDrawer);
    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  document.querySelectorAll('.product__drawer-trigger-wrapper').forEach(initDrawer);
})();
